import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-feb05aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增物品类型")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("启用中")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用中")
const _hoisted_5 = {
  key: 1,
  class: "btn_box"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_GoodsCateSet = _resolveComponent("GoodsCateSet")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "物品类型管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "dashed",
          onClick: _ctx.resetSearch,
          style: {"margin-right":"15px"}
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: false
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'is_enable')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              text
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "#87d068"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "#f50"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.setStatus(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!record.is_enable ? '启用' : '禁用'), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.setVisible(true, record))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      width: 700,
      title: _ctx.item ? '编辑物品分类' : '新增物品分类',
      footer: null,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setVisible(false )))
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_GoodsCateSet, {
          "edit-item": _ctx.item,
          key: _ctx.item?.id || 'key',
          reset: _ctx.onClose
        }, null, 8, ["edit-item", "reset"]))
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ], 64))
}